import { render, staticRenderFns } from "./PdfViewerV2.vue?vue&type=template&id=79383368&scoped=true"
import script from "./PdfViewerV2.vue?vue&type=script&lang=js"
export * from "./PdfViewerV2.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerV2.vue?vue&type=style&index=0&id=79383368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79383368",
  null
  
)

export default component.exports